import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Nav() {
  return (
    <header className="glass-nav sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <span className="font-display font-black tracking-tighter text-xl leading-none">
            12<span className="text-[#D92D20]">/</span>LAWS
          </span>
          <span className="hidden sm:inline-block text-[10px] uppercase tracking-[0.25em] text-[#525252] border-l border-black/10 pl-3">
            Dating Dynamics
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a href="/#laws" className="hover:text-[#D92D20] transition-colors" data-testid="nav-link-laws">The Laws</a>
          <a href="/#reviews" className="hover:text-[#D92D20] transition-colors" data-testid="nav-link-reviews">Reviews</a>
          <a href="/#author" className="hover:text-[#D92D20] transition-colors" data-testid="nav-link-author">Author</a>
          <a href="/#details" className="hover:text-[#D92D20] transition-colors" data-testid="nav-link-details">Details</a>
        </nav>
        <Link
          to="/checkout"
          className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white px-4 sm:px-5 py-2.5 text-sm font-medium hover:bg-[#D92D20] transition-colors"
          data-testid="nav-buy-cta"
        >
          Order Your Copy — $19.99
          <ArrowUpRight className="w-4 h-4" />
        </Link>
      </div>
    </header>
  );
}
